import { html } from 'lit';

export const DashboardHome = () => {
  return html`
    <div class="flex flex-col gap-6">
      <h1 class="text-3xl font-bold text-primary">SOURCE Dashboard</h1>
      <p class="text-lg text-base-content/80">Welcome to the SOURCE platform. Select a module to get started.</p>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
        <!-- Mails Card -->
        <a
          href="/mails"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-primary/10 p-4 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-primary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l9 6 9-6" />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Mails</h2>
                <p class="text-base-content/70">View and manage mails</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-primary">Mails</span>
              <span class="badge badge-outline">Odoo Tickets</span>
            </div>
          </div>
        </a>

        <!-- Odoo Tickets Card -->
        <a
          href="/odoo-tickets"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <!-- Tag icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 7h.01M7 3h6a1 1 0 01.707.293l7 7a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A1 1 0 013 13V7a4 4 0 014-4z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Odoo Tickets</h2>
                <p class="text-base-content/70">View and manage Odoo tickets</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">Tickets</span>
            </div>
          </div>
        </a>

        <!-- Intercom Card -->
        <a
          href="/intercom"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Intercom Conversations</h2>
                <p class="text-base-content/70">Manage intercom messages and responses</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">Support</span>
              <span class="badge badge-outline">Messages</span>
            </div>
          </div>
        </a>

        <!-- Contacts Card -->
        <a
          href="/contacts"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-info transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-info/10 p-4 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-info"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Contacts</h2>
                <p class="text-base-content/70">Manage customer and lead contacts</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-info">CRM</span>
              <span class="badge badge-outline">Customers</span>
            </div>
          </div>
        </a>

        <!-- Bad Contact Card -->
        <a
          href="/badcontact"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-info transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-info/10 p-4 rounded-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-info"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Incorrect Contacts</h2>
                <p class="text-base-content/70">Old/ duplicate contacts to delete and contacts with @ or brackets</p>
              </div>
            </div>
          </div>
        </a>

        <!-- All Answers Card -->
        <a
          href="/answering"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <!-- Document Text icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V7a2 2 0 012-2h5l5 5v9a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">All answers</h2>
                <p class="text-base-content/70">View answers and introspection for all channels</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">Tickets</span>
            </div>
          </div>
        </a>

        <!-- Task Queue Odoo -->
        <a
          href="/taskqueue"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <!-- View List icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Tasks Queue Odoo</h2>
                <p class="text-base-content/70">View all odoo tickets needing contacts, tags or priority</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">Tickets</span>
            </div>
          </div>
        </a>

        <!-- KPIs -->
        <a
          href="/kpis"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <!-- Chart Bar icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3v18h18M7 13v5m6-10v10m6-6v6" />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">KPIs</h2>
                <p class="text-base-content/70">View all odoo tickets needing contacts, tags or priority</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">Tickets</span>
            </div>
          </div>
        </a>

        <!-- Comments -->
        <a
          href="/comments"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <!-- Chat bubble icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
                  />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Comments</h2>
                <p class="text-base-content/70">View all odoo tickets needing contacts, tags or priority</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">Grouped from all types</span>
            </div>
          </div>
        </a>

        <!-- Knowledgebase -->
        <a
          href="/knowledgebase"
          class="card bg-base-100 shadow-xl border border-base-300 hover:border-primary transition-colors"
        >
          <div class="card-body">
            <div class="flex items-center gap-4">
              <div class="bg-secondary/10 p-4 rounded-lg">
                <!-- Collection/Books icon -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-8 w-8 text-secondary"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h10" />
                </svg>
              </div>
              <div>
                <h2 class="card-title text-xl">Knowledgebase Content</h2>
                <p class="text-base-content/70">View all product and category data</p>
              </div>
            </div>
            <div class="card-actions justify-end mt-4">
              <span class="badge badge-secondary">3-daily rescraping</span>
            </div>
          </div>
        </a>
      </div>
    </div>
  `;
};
